import { HttpParams } from '@angular/common/http';

export class ErrorInterceptorParams extends HttpParams {
    constructor(public options?: { errorHandling: boolean; }) {
        super();
    }
}
